import { Textarea } from "@chakra-ui/react";

import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { EssayQuestionProps } from "../types";

export const EssayQuestion = (props: EssayQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    placeholder,
    size,
    isDisabled,
    changeEventHandler,
    answerAriaLabel,
    answerProps,
    contentClassName,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps,
    locale
  } = props;

  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    questionId,
    labelClassName,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps,
    withErrorIcon,
    locale
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <Textarea
          id={questionId}
          value={answer}
          className={contentClassName}
          isDisabled={isDisabled}
          onChange={changeEventHandler}
          placeholder={placeholder}
          aria-label={answerAriaLabel}
          size={size}
          {...answerProps}
        />
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
